import React from 'react';
import { Grid } from '@mui/material';

import { BooleanDescField, CurrencyTextField, TagsSelectField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function CommercialCampaignsDetailsSectionSecondaryInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={12}>
				{/* TAGS */}
				<TagsSelectField
					name="cmcp_tags"
					label={t('DETAILS_COMMERCIALCAMPAIGNS_FIELD_TAGS')}
					value={props.model.cmcp_tags}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* WARNING */}
				<BooleanDescField
					name="cmcp_warning_desc"
					label={t('DETAILS_COMMERCIALCAMPAIGNS_FIELD_WARNING')}
					value={props.model.cmcp_warning_desc}
					icon="alert-outline"
					color="warning.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* BLOCKED */}
				<BooleanDescField
					name="cmcp_blocked_desc"
					label={t('DETAILS_COMMERCIALCAMPAIGNS_FIELD_BLOCKED')}
					value={props.model.cmcp_blocked_desc}
					icon="cancel"
					color="error.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* EXPENSES */}
				<CurrencyTextField
					name="cmcp_expenses"
					label={t('DETAILS_COMMERCIALCAMPAIGNS_FIELD_EXPENSES')}
					value={props.model.cmcp_expenses}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
